<template lang="html">
  <div class="animalthumbnails">
    <v-row justify="center">
      <v-col cols="6" md="3" lg="2" v-for="animal in animals" :key="animal.id" >
          <v-img
            :style="{'border-color':animal.colorcode ? animal.colorcode : 'transparent'}"
            class="thumbnailImg"
            :src="animal.thumbnailImage"
            @click="goTo(animal.id)"
          >  <v-icon v-if="animal.animal_of_week" color="red">mdi-heart</v-icon>
        </v-img>
        <div class="text-center" v-if="searchOn">
          {{animal.name}} <br/> /{{animal.shelterID}}/
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ['animals', 'searchOn'],
  data(){
    return {
    }
  },
  methods: {
    goTo(id){
      this.$router.push("/animal/" + id);
    }
  },
  computed:{
  },
}
</script>

<style lang="scss" scoped>
  .animalthumbnails{
    width: 80%;
    margin: 0 auto;
  }
  .animalthumbnails .v-icon{
    position: absolute;
    left: 8px;
    top: 5px;
    z-index: 20;
  }

  .thumbnailImg{
    transform: scale(0.9);
    border-radius: 15px;
    transition: transform 0.5s ease-in-out;
    height: 180px;
    border-left: 3px solid;
    border-bottom: 5px solid;

    &:hover{
    transition: transform 0.3s ease-in-out;
    transform: scale(1);
    cursor: pointer;
    }

    @media(max-width:500px){
      height: 120px;
    }
  }

  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .8;
    position: absolute;
    width: 100%;
    text-align: center;
  }
</style>
